import { Box, Typography } from "@mui/material";
import EventAccordion from "./EventAccordion";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { useTranslation } from "react-i18next";
import { InspectEventsResponse } from "../settingsApi";
import { useState } from "react";

type Props = {
  isLoading: boolean;
  events: InspectEventsResponse[];
  showEmptyState: boolean;
};

const EventAccodions = ({ isLoading, events, showEmptyState }: Props) => {
  const { t } = useTranslation("settings");
  const [expanded, setExpanded] = useState<number | boolean>(false);

  const handleChange = (index: number) => {
    if (expanded === index) return setExpanded(false);
    setExpanded(index);
  };

  return (
    <Box>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        events.map((event, index) => (
          <EventAccordion
            key={event.id}
            event={event}
            index={index}
            expanded={expanded}
            handleChange={handleChange}
          />
        ))
      )}
      {showEmptyState && <Typography>{t("eventsEmptyState")}</Typography>}
    </Box>
  );
};

export default EventAccodions;
